import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Providers } from './providers';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { consumeSsoToken } from './services/consumeSsoToken';

// Adopt any inbound SSO token from the URL before React mounts, so AuthProvider
// hydrates from it instead of bouncing to sign-in.
consumeSsoToken().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <Providers>
            <App />
          </Providers>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  );
});
